import { Box, Container, Stack, Typography } from "@mui/material";

import MarkColor from "@/assets/branding/mark_color.png";

export const MobileError = () => {
  return (
    <Container component="main">
      <Stack
        spacing={4}
        sx={{
          alignItems: "center",
          justifyContent: "center",
          pt: 12,
        }}
      >
        <Box component="img" sx={{ height: 64 }} src={MarkColor} alt="Layer" />
        <Typography
          variant="regular"
          component="p"
          sx={{
            color: "secondary.3",
            textAlign: "center",
            maxWidth: "42rem",
            py: 18,
          }}
        >
          Layer does not support mobile browsers yet.
          <br /> Please visit us on a desktop for the best experience.
        </Typography>
      </Stack>
    </Container>
  );
};
